import { lazy } from 'react';

const PurchaseOrderScreens = lazy(() =>
  import('../components/PurchaseOrder/Screens/PurchaseOrderScreens'),
);

const PurchaseOrderNonAssetScreens = lazy(() =>
  import('../pages/PurchaseOrderNonAsset'),
);

const purchaseOrderRoute = {
  public: [],
  auth: [
    {
      name: 'purchase_order',
      path: '/purchase-order',
      component: PurchaseOrderScreens,
    },
    {
      name: 'purchase_order_non_asset',
      path: '/purchase-order-non-asset/:status?',
      component: PurchaseOrderNonAssetScreens,
    },
  ],
};

export default purchaseOrderRoute;
